import { temAcesso } from '@/shared/auth/temAcesso'

const Requisicoes = () => import('./Requisicoes.vue')
const RequisicaoDetalhar = () => import('../../contratos/requisicoes/RequisicaoDetalhar')

export default {
    path: 'requisicoes',
    name: 'Gescon_Aprovadores_Requisicoes',
    component: Requisicoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-APR-REQ-00')) {
            next()
        }
    },
    children: [
        {
            path: ':requisicaoId',
            name: 'Gescon_Aprovadores_Requisicoes_Detalhar',
            component: RequisicaoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-APR-REQ-00')) {
                    next()
                }
            }
        }
    ]
}
